module.exports = __webpack_public_path__ + "static/media/my-worspace.c02eefc0.jpg";